'use strict';

var React = require('react');
var createReactClass = require('create-react-class');
var gMap = require('google-maps');
gMap.KEY = 'AIzaSyBuv3zCPctmPzqDxh6jcCzXuKM01Lu6slI';
var map, mapOptions;
var markers = [];
var googleMapsApi;

module.exports = createReactClass({
    displayName: 'exports',

    componentDidMount: function componentDidMount() {
        var that = this;
        gMap.load(function (google) {
            googleMapsApi = google;
            mapOptions = {
                center: { lat: 40.316084, lng: -96.067057 },
                zoom: 4
            };

            map = new google.maps.Map(that.refs.map_canvas.getDOMNode(), mapOptions);

            that.mapLoaded();

            that.props.locations.forEach(function (v, k) {
                var pos = new google.maps.LatLng(v.location.lat, v.location.lon);
                if (k === 0) {
                    map.panTo(pos);
                }
                markers.push(new google.maps.Marker({
                    position: pos,
                    map: map
                }));
            });
        });
    },
    mapLoaded: function mapLoaded() {
        if (this.props.mapLoaded) {
            this.props.mapLoaded();
        }
    },
    render: function render() {
        return React.createElement('div', { ref: 'map_canvas', className: 'map-canvas' });
    },
    componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
        markers.forEach(function (v) {
            v.setMap(null);
        });
        markers = [];
        nextProps.locations.forEach(function (v, k) {
            var pos = new googleMapsApi.maps.LatLng(v.location.lat, v.location.lon);
            if (k === 0) {
                map.panTo(pos);
                map.setZoom(15);
            }
            markers.push(new googleMapsApi.maps.Marker({
                position: pos,
                map: map
            }));
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/mapComponents/MapCanvas.js
// module id = 822
// module chunks = 0